
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XHeader from 'vux/src/components/x-header/index.vue'

import {mapState} from 'vuex'

export default {
name: 'app',
components: {Tabbar, TabbarItem, TransferDom, XHeader},
computed: {
...mapState({
isLoading: state => state.vux.isLoading,
direction: state => state.vux.direction
}),
},
methods: {
itemclick(e) {
this.$router.push({path: '/AddCommondity', query: e});
},
addCommondity() {
if (this.$store.state.vux.snsUserInfo.username == 'no') {
this.$router.push({path: '/'});
} else {
this.$router.push({path: '/'});
}

}
},
data() {
return {
tabbarIsSelected: [true, false, false],
headTitle: '',
comp_name: ''
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue